import { MDBDataTable } from "mdbreact";
import { React, useMemo, useState, useEffect, useContext } from "react";
import { API_BASE_URL } from "../../utils/config";
import axios from "axios";
// import { FaImage, FaUserEdit } from "react-icons/fa";
// import { MdDeleteForever } from "react-icons/md";
import MdDeleteForever from "../../Img/delete.png";
import FaUserEdit from "../../Img/edit user.png";
import SideBar from "../SideBar";
import TopNavBar from "../TopNavBar";
import Spinner from "../Spinner";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import Papa from "papaparse";
import DownloadCsv from "../../Img/bulk user download.png";
import { saveAs } from "file-saver";
import GlobalContext from "../../context/GlobalContext";
import { Link } from "react-router-dom";
import CreateCategoryImg from "../../Img/create tag.png";
import DetailsImg from "../../Img/details.png";
import UpdateImg from "../../Img/update.png";
import BackImg from "../../Img/back.png";
import SaveImg from "../../Img/save.png";
import NewTopNavBar from "../NewTopNavBar";
import BulkDelete from "../../Img/delete.png";
const NonplatfromUsers = () => {
  const [apiResponse, setApiRespose] = useState([]);
  const [tag, setTag] = useState([]);
  const [collaps, setCollaps] = useState(true);
  const [loader, setLoader] = useState(false);
  const [tagModalShow, setTagModalShow] = useState(false);
  const [categoryLoading, setCtegoryLoading] = useState(false);
  const [checkedRows, setCheckedRows] = useState([]);
  const [checkboxValue, setCheckboxValue] = useState([]);
  const [reload, setReload] = useState(false);
  const [disable, setDisable] = useState(true);
  const [categoryId, setCategoryId] = useState();
  const [show, setShow] = useState(false);
  const [editTagModalShow, setEditTagModalShow] = useState(false);
  const [filteredData, setFilteredData] = useState(); // Store filtered data
  const [showOlder, setShowOlder] = useState(false); // Toggle checkbox
  const [tagFormData, setTagFormData] = useState({
    username: "",
    id: "",
    email: "",
    access_from: "",
  });
  const { notificationCount, setNotificationCount } = useContext(GlobalContext);
  const [description, setDescription] = useState("");
  let bearerToken = localStorage.getItem("jwt_token");
  const config = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "application/json",
    },
  };
  const config2 = {
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      "Content-Type": "multipart/form-data",
    },
  };
  const changeCollapsState = () => {
    if (collaps) {
      setCollaps(false);
    } else {
      setCollaps(true);
    }
  };
  // Function to check if a timestamp is older than 6 months
  const isOlderThanSixMonths = (timeStamp) => {
    console.log("timestamp", timeStamp);
    // const sixMonthsAgo = new Date();
    // sixMonthsAgo.setMonth(sixMonthsAgo.getMonth() - 6); // Get date 6 months ago
    // const timeStampDate = new Date(timeStamp); // Convert timestamp to Date object
    // return timeStampDate < sixMonthsAgo; // Return true if timestamp is older

    //
    const fiveDaysAgo = new Date();
    fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 2); // Get date 5 days ago
    const timeStampDate = new Date(timeStamp); // Convert timestamp to Date object

    return timeStampDate < fiveDaysAgo; // Return true if timestamp is within 5 days

    // if (timeStampDate > fiveDaysAgo) {
    //   console.log("data469=", data);
    //   return data;
    // }
    //
  };

  // Handle checkbox change to filter data
  const filterData = () => {
    setShowOlder(!showOlder); // Toggle the checkbox
  };
  const getAllTags = () => {
    //const url="http://localhost/testsite"
    //API_BASE_URL
    const apiUrl = `${API_BASE_URL}/wp-json/custom/v1/get-oracle-user-data`;
    axios
      .get(apiUrl, config)
      .then((res) => {
        setApiRespose(res.data);
        //
        if (showOlder) {
          // const filterTime = res.data.data.filter((item) =>
          //   isOlderThanSixMonths(item.time_stamp, item)
          // );

          const filterTime = res.data.data.filter((item) => {
            const fiveDaysAgo = new Date();

            fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 7); // Get date 5 days ago
            const timeStampDate = new Date(item.time_stamp); // Convert timestamp to Date object
            console.log(`today= ${timeStampDate} prevDate= ${fiveDaysAgo}`);
            console.log("line115", timeStampDate > fiveDaysAgo);

            return timeStampDate < fiveDaysAgo; // Return true if timestamp is within 5 days
          });
          console.log("filterTime", filterTime);
          setTag(filterTime);
          // setTag(
          //   res.data.data.filter((item) =>
          //     isOlderThanSixMonths(item.time_stamp)
          //   )
          // );
        } else {
          setTag(res.data.data); // Show all data when unchecked

          const filterData = res.data.data.filter((item) => {
            const fiveDaysAgo = new Date();

            fiveDaysAgo.setDate(fiveDaysAgo.getDate() - 7); // Get date 5 days ago
            const timeStampDate = new Date(item.time_stamp); // Convert timestamp to Date object
            console.log(`today= ${timeStampDate} prevDate= ${fiveDaysAgo}`);
            console.log("line115", timeStampDate > fiveDaysAgo);

            return timeStampDate < fiveDaysAgo; // Return true if timestamp is within 5 days
          });

          console.log("filterData=", filterData);
          if (filterData.length > 0) {
            toast.warn(
              `click on show data older than six months checkbox and see their is ${filterData.length} six months older data present`
            );
          }
        }
        //
        // setTag(res.data.data);

        console.log("line73=", res.data);
        setLoader(true);
      })
      .catch((err) => {
        console.log(err);
        setLoader(true);
      });
  };

  let tagData = tag
    ? tag.map((data) => {
        console.log("line83=", data);
        let obj = {
          username: data.username,
          time_stamp: data.time_stamp,
          id: data.id,
          access_from: data.access_from,
          email: data.email,
        };
        return obj;
      })
    : "";

  const rolles = localStorage.getItem("roles");

  const CustomToastWithLinkDeleteTag = () => (
    <div>
      To delete this tag, please,
      <Link className="px-1" to="/table-posts">
        Click here
      </Link>
      to transfer associated articles.
    </div>
  );

  const handleDelete = (id, tag_name) => {
    const confirmed = window.confirm(
      "Are you sure you want to delete this user?"
    );
    if (!confirmed) {
      return;
    }
    setCtegoryLoading(false);
    axios
      .delete(
        `${API_BASE_URL}/wp-json/custom/v1/delete-oracle-user-data/${id}`,
        config
      )
      .then((res) => {
        toast.success("Data deleted successfully");
        setCtegoryLoading(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  let currentValue = [];
  let checkedCheckboxCount = [];
  const onchangeAuhtor = (e, current) => {
    const { id } = current;

    // setIsChecked(true)
    //

    if (e.target.checked) {
      setCheckedRows((prevCheckedRows) => [...prevCheckedRows, current.id]);
    } else {
      setCheckedRows((prevCheckedRows) =>
        prevCheckedRows.filter((id) => id !== current.id)
      );
    }

    //
    if (checkboxValue.some((value) => value.id === id)) {
      // If the current value is already in the array, remove it
      setCheckboxValue(checkboxValue.filter((value) => value.id !== id));
      checkedCheckboxCount = checkboxValue.filter((value) => value.id !== id);
    } else {
      // If the current value is not in the array, add it
      setCheckboxValue([...checkboxValue, current]);
      checkedCheckboxCount.push(current);
    }

    if (checkedCheckboxCount.length > 0) {
      setDisable(false);
    } else {
      setDisable(true);
    }

    console.log("476", checkboxValue);
  };

  const bulkDelete = () => {
    if (checkboxValue.length == 0) {
      toast.error("Please select users for delete.");
      // sd;
      return;
    } else {
      try {
        const confirmed = window.confirm(
          "Are you sure you want to delete this users?"
        );
        if (!confirmed) {
          return;
        }

        let postIds = [];
        for (let i = 0; i < checkboxValue.length; i++) {
          postIds.push(parseInt(checkboxValue[i].id));
        }
        // const apiEndpoint = `${API_BASE_URL}/wp-json/wp/v2/posts/${checkboxValue[i].id}`;
        const apiEndpoint = `${API_BASE_URL}/wp-json/custom/v1/delete-bulk-oracle-user-data`;
        console.log("line852=", postIds);

        // return;
        const config = {
          headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
          },
          data: { ids: postIds },
        };

        axios
          .delete(apiEndpoint, config)
          .then((response) => {
            toast.success("Users Deleted Successfully", {
              toastId: "category",
            });

            const postData = {
              postId: response.data.id,
            };

            setReload(reload ? false : true);
          })
          .catch((error) => {
            console.log("Error deleting Enter Code data:", error);
          });
        // }
        setDisable(true);
        setCheckboxValue([]);
      } catch (error) {
        console.error("Error fetching categories:", error);
      } finally {
        // setLoading(false);
      }
    }
  };
  // tag
  const data = useMemo(
    () => ({
      columns: [
        {
          label: "#",
          field: "checkbox",
          width: 300,
          sort: "disabled",
          fixedHeader: true,
        },
        {
          label: "User Name",
          field: "username",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "User Email",
          field: "email",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Access From",
          field: "access_from",
          width: 300,
          sort: "",
          fixedHeader: true,
        },
        {
          label: "Time Stamp",
          field: "time_stamp",
          width: 300,
          sort: "",
          fixedHeader: true,
        },

        {
          label: "Action",
          field: "delete",
          sort: "disabled",
          width: 100,
          fixed: true,
        },
      ],
      rows: tagData.map((e) => {
        let current = e;
        // let count = 0
        console.log("line250", current);
        // count++;
        return Object.assign(e, {
          // 'count': <div>{count + 1}</div>,
          Image: <img width={30} src={e.Image} alt="" />,
          checkbox: (
            <div>
              <input
                onChange={(e) => onchangeAuhtor(e, current)}
                type="checkbox"
                name=""
                id=""
                // checked={isChecked}

                checked={checkedRows.includes(current.id)}
              />
            </div>
          ),
          delete: (
            <div className="d-flex justify-content-center">
              {e.access_from == "Oracle" &&
              (e.email == null || e.email == "") ? (
                <img
                  className="mx-2"
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Edit"
                  role="button"
                  onClick={() => TagEdit(e)}
                  src={FaUserEdit}
                  alt=""
                />
              ) : (
                ""
              )}
              {localStorage.getItem("roles") == "administrator" ? (
                <img
                  className=""
                  data-toggle="tooltip"
                  data-placement="bottom"
                  title="Delete"
                  role="button"
                  onClick={() => handleDelete(e.id, e.name)}
                  src={MdDeleteForever}
                  alt=""
                />
              ) : (
                ""
              )}
              {/* <MdDeleteForever data-toggle="tooltip" data-placement="bottom" title="Delete"
                                onClick={() => handleDelete(e.id)}
                                size={25} color='#0d6efd' role='button'
                            /> */}
            </div>
          ),
          // checkbox: <div><input onChange={(e) => onchangeAuhtor(e, current)} type="checkbox" name="" id=""
          //     // checked={isChecked}
          //     checked={checkedRows.includes(current.id)}
          // /></div>
        });
      }),
    }),
    [tagData]
  );
  // tag
  const handleClose = () => {
    setEditTagModalShow(false);
    setTagModalShow(false);
    setDescription("");
    // setCreateUsersShow(false)
    // setCreateUsersFormData({ username: '', email: '', password: '', selectedRole: '' })
    // setErrors("")
  };
  // edit tag
  const TagEdit = (data) => {
    // setTagModalShow(true);
    // alert(id);
    console.log("data=", data);
    setTagFormData({
      id: data.id,
      username: data.username,
      access_from: data.access_from,
      email: data.email,
    });
    setEditTagModalShow(true);
    // axios
    //   .get(`${API_BASE_URL}/wp-json/wp/v2/tags/${id}`, config)
    //   .then((res) => {
    //     console.log(res.data);

    //     var tname = res.data.name;
    //     var tdescription = res.data.description;
    //     setDescription(tdescription);

    //     setTagFormData({
    //       id: res.data.id,
    //       description: tdescription,
    //       name: tname,
    //     });
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  const handleChangeUpdateTag = (e) => {
    if (e.target.name === "email") {
      setTagFormData({ ...tagFormData, email: e.target.value });
    }
  };
  const updateTag = (id) => {
    console.log("line270=", tagFormData);
    // alert("dgg");
    // return;
    const formData = {
      email: tagFormData.email,
      username: tagFormData.username,
      access_from: tagFormData.access_from,
    };
    setCtegoryLoading(false);
    axios
      .put(
        `${API_BASE_URL}/wp-json/custom/v1/oracle-user-data/${id}`,
        formData,
        config
      )
      .then((res) => {
        setDescription("");

        setEditTagModalShow(false);

        setCtegoryLoading(true);
        setTagModalShow(false);
        toast.success("Email Updated Successfully");
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const downloadCSV = () => {
    const headers = "UserName,AccessFrom,TimeStamp\n";
    // console.log("users=", users[0].role);
    // return;
    // .join(", ")
    const userRows = tag
      .map(
        (user) => `${user.username},${user.access_from},${user.time_stamp}\n`
      )
      .join("");
    const csvContent = headers + userRows;

    const blob = new Blob([csvContent], {
      type: "text/csv;charset=utf-8;",
    });
    saveAs(blob, "users.csv");
  };

  // edit tag

  useEffect(() => {
    // alert("kjfvj")
    // const apiUrl = `${API_BASE_URL}/wp-json/wp/v2/categories?per_page=100`
    //

    //
    getAllTags();
  }, [categoryLoading, reload, showOlder]);

  //

  useEffect(() => {
    let thead = document.querySelectorAll("th");

    for (let i = 0; i < thead.length; i++) {
      if (rolles == "administrator" || "author") {
        if (i == 0) {
          thead[i].style.cssText = `width:8%; `;
        }
        if (i === 1) {
          thead[i].style.cssText = `width:30%; `;
        }
        if (i === 2) {
          thead[i].style.cssText = `width:30%; `;
        }
      }
      // else {
      //   if (i === 0) {
      //     thead[i].style.cssText = `width:35%; `
      //   }
      // }
    }
  }, [tag]);

  //

  return (
    <div>
      <div className="row g-0">
        <div
          style={{ minHeight: "90vh" }}
          className={
            collaps ? "column right-column  col" : "column right-column  col "
          }
        >
          <div className="w-100">
            <NewTopNavBar />
          </div>
          {/* update tag */}
          <Modal show={editTagModalShow} onHide={handleClose} centered>
            <Modal.Header closeButton>
              <Modal.Title>Add/Update Email</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              {" "}
              <div className="row g-0 w-100 ">
                <div className="col-3"></div>
                <div className="col-12">
                  <form>
                    <div className="form-group">
                      <label className="fw-bold" for="exampleInputEmail1">
                        Email<span className="text-danger">* </span> :
                      </label>
                      <input
                        className="form-control my-2"
                        type="text"
                        name="email"
                        value={tagFormData.email}
                        placeholder="Enter Email"
                        onChange={handleChangeUpdateTag}
                        required
                      />

                      {/* <label className="fw-bold" for="exampleInputEmail1">
                        Description :
                      </label>
                      <input
                        className="my-2 form-control"
                        placeholder="Enter Description"
                        type="text"
                        name="description"
                        value={description}
                        // onChange={handleDescription}
                      /> */}

                      {/* {errors.username && <p className="error">{errors.username}</p>} */}
                    </div>

                    {/*  */}
                    <div className="mt-2 text-end">
                      {/* <button onClick={() => updateCategory(tagFormData.id)} type="button" className="btn btn-primary">Update</button> */}
                      <img
                        className="commonLogo"
                        // height={40}
                        onClick={() => updateTag(tagFormData.id)}
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="Update"
                        role="button"
                        src={UpdateImg}
                        alt=""
                      />
                    </div>
                  </form>
                </div>
                <div className="col-3"></div>
              </div>
            </Modal.Body>
          </Modal>
          {/* update tag */}
          {console.log("loader", loader)}
          {loader ? (
            <div>
              <div
                className="w-100"
                style={{ minHeight: "80vh", padding: "15px 20px 10px 40px" }}
              >
                <div
                  style={{
                    // background: '#ececec',
                    boxShadow: "5px 5px 10px rgba(0, 0, 0, 0.5)",
                    // margin: '20px 30px'
                  }}
                  className="row w-100"
                >
                  <div className="col-12 px-5 pt-2">
                    <div className="row g-0">
                      <div className="col-8">
                        <div className="pt-3">
                          {/* <h2 className='text-center'>Knowledge Repository</h2> */}
                          <h2 className="ps-3">Login Tracker</h2>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div></div>
                      {tag.length > 0 ? (
                        <div className=" d-flex justify-content-between">
                          <div>
                            <label>
                              <input
                                type="checkbox"
                                checked={showOlder}
                                onChange={filterData}
                              />
                              Show data older than 6 months
                            </label>
                          </div>
                          <div style={{}}>
                            {/* <button className='btn  btn-primary ' onClick={createusersHandleChange}>+Create User</button> */}
                            <img
                              className=" me-1  commonLogo"
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Bulk Delete"
                              role="button"
                              onClick={bulkDelete}
                              src={BulkDelete}
                              alt=""
                            />
                            <img
                              // width={40}
                              className="commonLogo"
                              onClick={downloadCSV}
                              data-toggle="tooltip"
                              data-placement="bottom"
                              title="Download Users"
                              role="button"
                              src={DownloadCsv}
                              alt=""
                            />
                          </div>
                        </div>
                      ) : (
                        ""
                      )}

                      {rolles == "administrator" ? (
                        <MDBDataTable
                          // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                          fixed
                          sortable
                          bordered
                          autoWidth={false}
                          data={data}
                          entries={5}
                          entriesOptions={[5, 10, 15, 20]}
                          noBottomColumns
                          disableRetreatAfterSorting={true}
                        />
                      ) : (
                        <MDBDataTable
                          // noRecordsFoundLabel={`${articleData.length < 1 ? 'Create your first article  by clicking on "+ CREATE ARTICLE" button' : 'No matching records found'}`}
                          fixed
                          sortable
                          bordered
                          autoWidth={false}
                          data={data}
                          entries={5}
                          entriesOptions={[5, 10, 15, 20]}
                          noBottomColumns
                          disableRetreatAfterSorting={true}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            <div className="text-center w-100 my-5">
              <Spinner />
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NonplatfromUsers;
